import React, { Component } from 'react'
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  Input,
} from "reactstrap";

import Messages from '../../notifications/Messages'
import Errors from '../../notifications/Errors'

export default class DiemTichLuyEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      requesting: false,
      DiemTichLuy: null,
      errors: [],
      messages: [],
    }
  }
  valueChange = ({target}) => {
    let val = target.value
    if (isNaN(val)) {
      val = null
    }
    this.setState({hasChanged: true, DiemTichLuy: val})
  }
  onSuccess = (message) => {
    this.setState({
      messages: [
      {
        body: message,
        time: new Date(),
      }
    ]})

    setTimeout(() => {
      this.setState({requesting: false}, () => {
        this.props.onClose(true)
      })
    }, 1000)
  }
  onError = (error) => {
    this.setState({
      requesting: false,
      errors: [
      {
        body: error.toString(),
        time: new Date(),
      }
    ]})
  }
  updateDiemTichLuy = () => {
    const formRequest = {
      diemTichLuy: this.state.DiemTichLuy,
      id: this.props.Id,
      loai: this.props.Loai
    }
    this.setState({requesting: true}, () => {
      this.props.onSave(formRequest, this.onSuccess, this.onError)
    })
  }
  onClose = () => {
    this.props.onClose()
  }
  render() {
    const {
      DiemTichLuy,
      modalEditDiem
    } = this.props
    const {
      requesting,
      errors,
      messages,
    } = this.state
    const btnDisalbed = requesting || !this.state.DiemTichLuy
    return (
      <div className="animated fadeIn">
        <Modal isOpen={modalEditDiem} className="modal-md" modalClassName={"order-approve-cfm"}>
          <ModalHeader>Cập nhật điểm tích luỹ</ModalHeader>
          <ModalBody>
            <div className="col-sm-12  mb-1 pl-0 pr-0">
              <div className="input-group input-group-md display-table">
                <div className="input-group-prepend">
                  <span className="input-group-text">Điểm hiện tại: {DiemTichLuy}</span>
                </div>
              </div>
            </div>
            <div className="col-sm-12  mb-1 pl-0 pr-0">
              <div className="input-group input-group-md">
                <Input className="text-right" name="DiemTichLuy" placeholder="Điểm tích luỹ mới" maxLength={11} type="text" value={this.state.DiemTichLuy || ''} onChange={e => this.valueChange(e)} />
              </div>
            </div>
            <div className="col-sm-12 pl-0 pr-0">
              {!requesting && !!errors.length && (
                <Errors message="Failure to signup due to:" errors={errors} />
              )}
              {!messages.length && (
                <Messages messages={messages} />
              )}
            </div>
            <div className="col-sm-12 pl-0 pr-0">
              <div className="btn-group float-right" role="group">
                <Button disabled={btnDisalbed} className="btn btn-success mr-1" onClick={() => this.updateDiemTichLuy()}>
                  <i className="fa fa-check"></i><span className="d-none d-sm-inline">&nbsp;Lưu</span></Button>
                <Button className="btn btn-secondary" onClick={() => this.onClose()}>
                  <i className="fa fa-arrow-left"></i><span className="d-none d-sm-inline">&nbsp;Đóng</span></Button>
              </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/views/KhachHang/_DiemTichLuyEdit.js